import { Box, Button, VStack, Heading, Span, Text } from '@bpba/ui-components';
import React, { useState } from 'react';
import { SubmitHandler, useForm } from "react-hook-form";
import { useMutation } from '@apollo/client';
import { Mutations } from '../rest/Mutations';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';

import { postPUSF } from '../rest/mutations/postPUSF';
import { PUSFApiRQ } from '../rest/models/PUSFApiRQ';
import { PUSFModel } from '../rest/models/PUSFModel';
import { useTurnstile } from 'react-turnstile';

export const PUSFComponente: React.FC = () => {

    const { register, handleSubmit, formState: { errors }, reset } = useForm<any>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        defaultValues: {
            sucursal: ""

        }
    });

    const REQUIRED_FIELD = "Campo requerido.";
    const [postFormPUSF, { loading: loadingPusfPost }] = useMutation<Mutations>(postPUSF);
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<React.ReactNode>(null);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>(<></>);
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [getTrnToken, setGetTrnToken] = useState<boolean>(false);
    const numberValidator = /^\d+$/;
    const toknTurnstile = useTurnstile();

    const onSubmit: SubmitHandler<PUSFModel> = async (data: PUSFModel) => {

        setGetTrnToken(true);

        let datos: PUSFApiRQ = {
            "googleToken": "",
            "name": data.name,
            "lastName": data.lastName,
            "identityDocumentNumber": Number(data.identityDocumentNumber),
            "claimNumber": Number(data.claimNumber),
            "detail": data.detail
        };
        toknTurnstile.execute(document.getElementById('turnStileTkncontainer'), {
            sitekey: process.env.REACT_APP_TKN_SITEKEY!,
            callback: async (token: any) => {
                datos.googleToken = token

                await postFormPUSF({ variables: { input: datos } }).then((response: any) => {
                    setGetTrnToken(false);
                    if (response !== null || response !== undefined) {
                        setServicioOk(true);
                        setMensajeRtaServicio(<><Text tabIndex={0} fontSize={"20px"} margin={0} fontWeight={600}>¡Gracias por enviarnos tu consulta! <br />Tu solicitud fue registrada con éxito bajo el número {response.data.PUSFApiRS.claimNumber}.<br />Te mantendremos informado/a sobre cualquier novedad.</Text><Text fontSize={"16px"} margin={0}></Text> </>);

                    } else {
                        setServicioOk(true);
                        setMensajeRtaServicio(<Text tabIndex={0} fontSize={"20px"} margin={0} fontWeight={600}>Tuvimos un problema. Volvé a intentar más tarde y si el error continúa comunicate al 0810-666-0098</Text>);
                    }

                }).catch((e) => {
                    setGetTrnToken(false);

                    if (e.networkError.statusCode === 409) {
                        setServicioOk(false);
                        setMensajeErrorPostProspecto(<Text tabIndex={0} fontSize={"20px"} margin={0} fontWeight={600} dangerouslySetInnerHTML={{__html: JSON.parse(JSON.stringify(e.networkError)).result.detail}}></Text>);

                    } else {
                        setServicioOk(false);
                        setMensajeErrorPostProspecto(<Text tabIndex={0} fontSize={"20px"} margin={0} fontWeight={600}>Tuvimos un problema. Volvé a intentar más tarde y si el error continúa comunicate al 0810-666-0098</Text>);

                    }

                });
            }
        });


    }


    const handleReset = () => {
        reset({});
        window.location.reload();
    };

    if (getTrnToken || loadingPusfPost) return <SpinnerCajas />;


    if (servicioOk) return (
        <VStack>
            <VStack>
                <Heading level={2} fontWeight={400} color="primary.0" tabIndex={0}>{mensajeRtaServicio}</Heading>
            </VStack>

            <Button
                onClick={() => handleReset()}
                variant="secondary"
                py={"10px !important"}
            >
                Volver
            </Button>
        </VStack>

    );
    if (mensajeErrorPostProspecto !== null && !servicioOk) return (

        <VStack>
            
                <VStack>
                    <Heading level={2} fontWeight={400} color={"red"} tabIndex={0}>{mensajeErrorPostProspecto}</Heading>
                </VStack>
      
            <Button
                onClick={() => handleReset()}
                variant="secondary"
                py={"10px !important"}
            >
                Volver
            </Button>
        </VStack>


    );
    return (


        <Box>
            <VStack>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Heading level={3} mb={'2px'} fontWeight={400} tabIndex={0}>
                        Datos Generales
                    </Heading>

                    <VStack mt={"20px"}>
                        <input {...register(`name`, { required: REQUIRED_FIELD, maxLength: 300 })} name='name' type={"text"} placeholder='Nombre' maxLength={300} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.name ? "* " + errors.name.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input {...register(`lastName`, { required: REQUIRED_FIELD, maxLength: 300 })} name='lastName' type={"text"} placeholder='Apellido' maxLength={300} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.lastName ? "* " + errors.lastName.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input {...register(`identityDocumentNumber`, { required: REQUIRED_FIELD, minLength: { value: 8, message: "Debe tener al menos 8 dígitos" } })} maxLength={8} name='identityDocumentNumber' placeholder='DNI' type={"text"} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.identityDocumentNumber ? "* " + errors.identityDocumentNumber.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <input {...register(`claimNumber`, { required: REQUIRED_FIELD, pattern: { value: numberValidator, message: "El campo debe ser numérico" }, minLength: { value: 7, message: "Debe tener 8 dígitos" } })} minLength={7} maxLength={8} name='claimNumber' placeholder='Nro de reclamo' type={"text"} />
                        <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.claimNumber ? "* " + errors.claimNumber.message : ""}</Span>
                    </VStack>
                    <VStack mt={"20px"}>
                        <Span color="primary.0" marginBottom={"8px"} fontSize={"14px"} style={{ lineHeight: "18px" }}>
                            Consulta
                        </Span>


                        <VStack>
                            <textarea style={{ border: "none", borderBottom: "1px solid black", outlineColor: "#25b4b", minHeight: "calc(1.5em + 0.75rem + 2px)", color: "#49505", fontFamily: "Encode Sans, sans-serif", padding: "0.375rem 1.75rem 0.375rem 0.75rem", lineHeight: "18px" }}
                                {...register(`detail`, { required: REQUIRED_FIELD, maxLength: 2000 })} name='detail' placeholder='Detalle de la consulta' maxLength={2000} />
                            <Span color="red" fontSize={"12px"} tabIndex={0}>{errors.detail ? "* " + errors.detail.message : ""}</Span>
                        </VStack>
                    </VStack>

                    <Button type="submit" variant="secondary" marginBottom={"24px"} style={{ height: "calc(1.8em + 0.75rem + 2px)" }} py={'10px !important'}>Enviar</Button>



                </form>
            </VStack>

        </Box>

    )

};

